var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _line, _line2, _line3, _path10, _path11, _path12, _path13, _rect, _rect2, _rect3, _path14, _line4, _rect4, _line5, _line6, _line7, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _ellipse, _rect5, _rect6, _rect7, _path26, _path27, _line8, _path28, _line9, _circle, _circle2, _rect8, _ellipse2, _path29, _path30, _path31, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _circle3, _circle4, _path32, _path33, _path34, _path35, _line0, _path36, _path37, _path38, _ellipse7, _path39, _path40, _path41, _ellipse8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "skinGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#c47a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7a3e1a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cloakGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2a3a3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#1a252a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0d1618"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cloakRimL",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#c47a3a",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a252a",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "leatherGrad",
    x1: 0,
    y1: 0,
    x2: 0.3,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4a3018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2a1a08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plateGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6a5a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#4a3e22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2e2610"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plateRim",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#c8a050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3a2e10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bladeGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f5c040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#e87820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5a2a08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "handleGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3a2810"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1e1408"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faceGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b86828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5a2e0e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hairGrad",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2a1a08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#180e04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "satchelGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5a3a18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2e1a08"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "runeGlow",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffe060",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#f08020",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#c04010",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bootGrad",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3a2a14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a1008"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pantGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2a3028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#181e18"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 105 Q70 120 58 160 Q52 185 55 215 Q68 210 78 195 Q82 170 90 155 Z",
    fill: "url(#cloakGrad)",
    opacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148 105 Q165 122 175 155 Q183 178 180 215 Q168 208 160 192 Q155 168 148 148 Z",
    fill: "url(#cloakGrad)",
    opacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88 105 Q70 120 58 160 Q52 185 55 215 Q60 210 63 195 Q68 170 78 150 Q83 130 90 115 Z",
    fill: "url(#cloakRimL)",
    opacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M175 155 Q185 170 188 200 Q180 205 174 195 Q170 178 165 162 Z",
    fill: "#1a252a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175 155 Q183 170 186 198 Q181 202 176 195 Q172 178 167 162 Z",
    fill: "#e8943a",
    opacity: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55 215 Q48 225 52 235 Q60 230 65 218 Z",
    fill: "#1a252a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65 218 Q60 228 66 238 Q74 232 76 220 Z",
    fill: "#1e2a2e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76 220 Q74 232 82 238 Q87 228 85 218 Z",
    fill: "#1a252a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160 192 Q155 210 158 228 Q166 225 170 212 Q167 202 163 195 Z",
    fill: "#1a252a"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M170 212 Q166 225 172 232 Q178 226 178 216 Z",
    fill: "#1e2a2e"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M92 108 Q90 125 88 148 Q100 155 120 156 Q140 155 152 148 Q150 125 148 108 Q136 102 120 100 Q104 102 92 108 Z",
    fill: "url(#leatherGrad)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 115,
    x2: 108,
    y2: 118,
    stroke: "#1a0e04",
    strokeWidth: 0.7,
    opacity: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 97,
    y1: 125,
    x2: 112,
    y2: 128,
    stroke: "#1a0e04",
    strokeWidth: 0.7,
    opacity: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 145,
    y1: 115,
    x2: 132,
    y2: 118,
    stroke: "#1a0e04",
    strokeWidth: 0.7,
    opacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88 108 Q78 104 72 112 Q70 122 78 128 Q86 132 92 125 Q94 116 88 108 Z",
    fill: "url(#plateGrad)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88 108 Q78 104 72 112 Q70 118 74 122",
    stroke: "url(#plateRim)",
    strokeWidth: 1.5,
    fill: "none",
    opacity: 0.9
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M152 108 Q162 104 168 112 Q170 122 162 128 Q154 132 148 125 Q146 116 152 108 Z",
    fill: "url(#plateGrad)",
    opacity: 0.75
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M162 104 Q168 110 168 118",
    stroke: "#c8a050",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 146,
    width: 60,
    height: 8,
    rx: 2,
    fill: "#2a1a08"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 144,
    width: 12,
    height: 12,
    rx: 1,
    fill: "url(#plateGrad)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 146,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#c8a050",
    opacity: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M82 150 Q76 152 74 162 Q72 175 77 180 Q84 182 90 178 Q95 170 93 158 Q90 150 82 150 Z",
    fill: "url(#satchelGrad)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 150,
    x2: 88,
    y2: 148,
    stroke: "#3a2010",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 162,
    width: 16,
    height: 12,
    rx: 2,
    fill: "#3a2010"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 168,
    x2: 91,
    y2: 168,
    stroke: "#c8a050",
    strokeWidth: 0.8,
    opacity: 0.7
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 155,
    x2: 78,
    y2: 162,
    stroke: "#5a3a18",
    strokeWidth: 1.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 83,
    y1: 154,
    x2: 83,
    y2: 162,
    stroke: "#5a3a18",
    strokeWidth: 1.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90 155 Q88 178 86 205 Q92 208 100 206 Q106 182 108 158 Z",
    fill: "url(#pantGrad)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M150 155 Q152 178 154 205 Q148 208 140 206 Q134 182 132 158 Z",
    fill: "url(#pantGrad)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M86 205 Q82 218 80 228 Q88 232 96 228 Q100 215 100 205 Z",
    fill: "url(#bootGrad)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M80 226 Q78 232 82 236 Q90 234 96 230 L96 228 Z",
    fill: "#0e0804"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M154 205 Q158 218 160 228 Q152 232 144 228 Q140 215 140 205 Z",
    fill: "url(#bootGrad)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M160 226 Q162 232 158 236 Q150 234 144 230 L144 228 Z",
    fill: "#0e0804"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M88 112 Q80 120 76 138 Q74 148 78 152 Q84 154 88 148 Q92 138 92 125 Z",
    fill: "url(#skinGrad)",
    opacity: 0.85
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78 138 Q74 148 78 152 Q84 154 88 148 Q86 142 84 136 Z",
    fill: "#5a2e10",
    opacity: 0.7
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M148 112 Q158 118 166 130 Q172 142 170 152 Q162 158 156 150 Q150 140 150 128 Z",
    fill: "url(#skinGrad)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M162 140 Q168 146 170 154 Q164 160 158 156 Q154 148 156 142 Z",
    fill: "#2a1a08"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M162 140 Q168 144 169 150",
    stroke: "#c8a050",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 182,
    cy: 138,
    rx: 18,
    ry: 32,
    fill: "url(#runeGlow)",
    opacity: 0.5,
    transform: "rotate(-20 182 138)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 148,
    width: 6,
    height: 18,
    rx: 2,
    fill: "url(#handleGrad)",
    transform: "rotate(-25 169 157)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 144,
    width: 18,
    height: 5,
    rx: 2,
    fill: "#6a5a2a",
    transform: "rotate(-25 169 147)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 144,
    width: 18,
    height: 3,
    rx: 1,
    fill: "#c8a050",
    opacity: 0.7,
    transform: "rotate(-25 169 147)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M168 142 L178 108 L184 105 L182 142 Z",
    fill: "url(#bladeGrad)",
    transform: "rotate(-5 176 124)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M178 108 L184 105 L183 128",
    stroke: "#ffe080",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.9,
    transform: "rotate(-5 181 116)"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 176,
    y1: 138,
    x2: 181,
    y2: 108,
    stroke: "#f0a030",
    strokeWidth: 0.8,
    opacity: 0.7,
    transform: "rotate(-5 178 123)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M171 130 L174 120 L177 130",
    stroke: "#ffe060",
    strokeWidth: 0.9,
    fill: "none",
    opacity: 0.85,
    transform: "rotate(-5 174 125)"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 125,
    x2: 178,
    y2: 125,
    stroke: "#ffe060",
    strokeWidth: 0.7,
    opacity: 0.8,
    transform: "rotate(-5 174 125)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 183,
    cy: 103,
    r: 3,
    fill: "#ffe080",
    opacity: 0.9,
    transform: "rotate(-5 183 103)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 183,
    cy: 103,
    r: 5,
    fill: "#f09020",
    opacity: 0.35,
    transform: "rotate(-5 183 103)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 90,
    width: 12,
    height: 14,
    rx: 3,
    fill: "url(#faceGrad)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 122,
    cy: 78,
    rx: 18,
    ry: 20,
    fill: "url(#faceGrad)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M104 70 Q104 78 106 86 Q110 92 118 92 Q112 88 108 80 Q106 74 108 68 Z",
    fill: "#3a1a06",
    opacity: 0.6
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M136 72 Q140 78 138 86 Q134 90 130 92 Q134 88 137 82 Q139 76 137 70 Z",
    fill: "#e8943a",
    opacity: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M108 68 Q114 62 122 61 Q130 62 136 68 Q130 64 122 63 Q114 64 108 68 Z",
    fill: "#2a1206",
    opacity: 0.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115,
    cy: 73,
    rx: 4,
    ry: 2.5,
    fill: "#1a0e04"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 129,
    cy: 72,
    rx: 4,
    ry: 2.5,
    fill: "#1a0e04"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116,
    cy: 73,
    rx: 2,
    ry: 1.5,
    fill: "#d4a070",
    opacity: 0.8
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130,
    cy: 72,
    rx: 2.5,
    ry: 1.5,
    fill: "#d4a070",
    opacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 117,
    cy: 73,
    r: 1.2,
    fill: "#0e0804"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 72,
    r: 1.2,
    fill: "#0e0804"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M111 68 Q115 66 119 67",
    stroke: "#2a1206",
    strokeWidth: 1.2,
    fill: "none"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M125 67 Q129 65 133 67",
    stroke: "#2a1206",
    strokeWidth: 1.2,
    fill: "none"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M121 75 Q119 80 120 83 Q122 84 124 83 Q125 80 123 75",
    stroke: "#2a1006",
    strokeWidth: 0.8,
    fill: "none",
    opacity: 0.6
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M115 86 Q122 88 129 86",
    stroke: "#2a1006",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.7
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 88,
    x2: 123,
    y2: 92,
    stroke: "#7a3a18",
    strokeWidth: 0.8,
    opacity: 0.6
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M104 68 Q106 56 114 52 Q122 48 130 52 Q138 56 140 68 Q136 60 130 57 Q122 54 114 57 Q108 60 104 68 Z",
    fill: "url(#hairGrad)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M104 68 Q102 62 106 56",
    stroke: "#180e04",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.8
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M136 58 Q140 54 138 50 Q134 54 136 58 Z",
    fill: "#1a0e04"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135,
    cy: 130,
    rx: 20,
    ry: 18,
    fill: "#e87820",
    opacity: 0.07
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M88 108 Q80 112 72 126 Q68 138 70 148",
    stroke: "#2a3a3e",
    strokeWidth: 3,
    fill: "none"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M70 148 Q66 158 62 172 Q58 190 60 210",
    stroke: "#1e2e32",
    strokeWidth: 2.5,
    fill: "none"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M88 108 Q80 112 72 128",
    stroke: "#c47a3a",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.7
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 118,
    cy: 237,
    rx: 42,
    ry: 5,
    fill: "#0a0804",
    opacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperator);
export default __webpack_public_path__ + "static/media/operator.2176ae22ec9a0d5bf84509c46c9c0677.svg";
export { ForwardRef as ReactComponent };